import request, { getToken } from '../api';
import { isValidFilename } from '@/utils/index';
export function getUploadConfig(file) {
  const invalidChars = /[<>:"/\\|#?*\x00-\x1F]/;
  let fileName = file.name;

  // 如果文件名不包含非法字符,使用时间戳作为文件名
  if (invalidChars.test(fileName)) {
    const ext = fileName.substring(fileName.lastIndexOf('.'));
    const date = new Date();
    const timestamp = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(
      2,
      '0'
    )}${String(date.getHours()).padStart(2, '0')}${String(date.getMinutes()).padStart(2, '0')}${String(
      date.getSeconds()
    ).padStart(2, '0')}`;
    fileName = timestamp + ext;
  }

  return request({
    url: '/common/upload/directUpload',
    method: 'post',
    data: { fileName },
    headers: {
      Authorization: getToken() || '',
    },
  });
}

export function directUpload(url, file) {
  return request.put(url, file, {
    headers: {
      'Content-Type': file.type || 'application/octet-stream',
    },
  });
}
